import { render } from "./SemestersTab.vue?vue&type=template&id=4ac54df8&scoped=true"
import script from "./SemestersTab.vue?vue&type=script&lang=js"
export * from "./SemestersTab.vue?vue&type=script&lang=js"

import "./SemestersTab.vue?vue&type=style&index=0&id=4ac54df8&scoped=true&lang=css"
import "./SemestersTab.vue?vue&type=style&index=1&id=4ac54df8&lang=css"
script.render = render
script.__scopeId = "data-v-4ac54df8"

export default script